<template>
  <product-form v-if="product"
    @submit="submit"
    :init-product="product"
    :custom-categories="customCategories"
    :val-errors="valErrors"
    submit-text="Speichern"
    :uploading="uploading"
  />
</template>

<script>
import ProductForm from './product-form'

export default {
  components: { ProductForm },
  data () {
    return {
      product: null,
      customCategories: [],
      valErrors: [],
      uploading: false
    }
  },
  methods: {
    async submit (product) {
      await this.initCsrf()

      this.valErrors = []
      this.$http.put(`/products/${product.id}`, product).then(({ data }) => {
        this.$notify({
          message: 'Produkt erfolgreich bearbeitet.',
          type: 'success'
        })
        this.redirectBack('/products')
      }).catch(({ response }) => { this.valErrors = response.data.errors })
    }
  },
  created () {
    this.$http.get(`/products/${this.$route.params.id}`).then(({ data }) => {
      const product = data
      product.product_features = product.product_features.reduce((features, feature) => {
        features[feature.custom_category_id] = feature
        return features
      }, {})
      this.$http.get('/custom_categories').then(({ data }) => {
        let customCategories
        if (product.is_variation_of) {
          customCategories = data.filter(customCategory => product.product_features[customCategory.id])
        } else {
          customCategories = data
          customCategories.forEach(customCategory => {
            if (!product.product_features[customCategory.id]) {
              product.product_features[customCategory.id] = {
                custom_category_id: customCategory.id,
                feature_id: null,
                feature: null,
                feature_option_id: null,
                feature_option: null,
                feature_option_value: null
              }
            }
          })
        }
        this.product = product
        this.customCategories = customCategories
      })
    })
  }
}
</script>

<style>
</style>
